export class SendYourDataManifestTagModel {
    tag;
    name;
}
//# sourceMappingURL=send-your-data-manifest-tag.js.map